import { DateFormatter } from '@repo/toolkit/date'

import { getTranslatedName } from '../../../utils/functions/translation.functions'
import { Transfer } from './transfer'

export class TransferProperties {
  static getLabel(transfer: Transfer): string {
    const labels: string[] = []

    labels.push(`T${transfer.id}`)
    labels.push(getTranslatedName(transfer.transportMeans))

    // get the time of the transfer
    const departureTime = DateFormatter.HHmm(DateFormatter.createDate(transfer.departureTime))
    const arrivalTime = DateFormatter.HHmm(DateFormatter.createDate(transfer.arrivalTime))
    labels.push(`(${departureTime} - ${arrivalTime})`)

    labels.push(`${transfer.numberOfStudents} places restantes`)

    return labels.join(' - ')
  }
}
